import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/Card";

export default function AdminRbacPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Roles & Permissions</h1>
        <p className="text-sm text-slate-500 dark:text-slate-400">Manage RBAC policies (coming soon).</p>
      </div>
      <Card>
        <CardContent className="py-12 text-center">
          <p className="text-slate-500 dark:text-slate-400">Role-based access control will be implemented in a future phase.</p>
        </CardContent>
      </Card>
    </div>
  );
}
